<template>
    <div class="authorized-person-kyc-report-modal">
        <JsonEditorVue
            v-model="kycReport"
            :stringified="true"
            :readOnly="true"
            mode="text"
            class="json-editor mb-5"
        />
        <div class="flex justify-start gap-2">
            <CoreButton
                variant="tertiary"
                label="§ui_button.close"
                @click="modalStore.setClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import JsonEditorVue from 'json-editor-vue'
import CoreButton from '@/components/core/CoreButton.vue'
import AuthorizedPersonService from '@/api/AuthorizedPersonService.js'
export default {
    name: 'AuthorizedPersonKycReportModal',

    components: {
        JsonEditorVue,
        CoreButton,
    },

    data() {
        return {
            modalStore: useModalStore(),
            kycReport: null,
            personId: null,
            loading: false,
        }
    },

    mounted() {
        this.personId = this.modalStore.data.authorizedPersonId
        this.fetchKycReport()
    },

    methods: {
        async fetchKycReport() {
            this.loading = true
            try {
                const response = await AuthorizedPersonService.getRawDnbReport({
                    authorizedPerson: this.personId,
                })
                this.kycReport = response
            } catch (error) {
                console.error('Error fetching KYC report:', error)
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped>
.authorized-person-kyc-report-modal {
    .json-editor {
        & .jse-json-node.jse-root.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,
        .jse-main.svelte-ybuk0j {
            min-height: 500px;
        }
    }
}
</style>
